export const AI_GOVERNANCE_FUNCTIONALITY_ID = 116

export function isAiGovernanceUiEnabled() {
    return String(process.env.VUE_APP_THALAMUS_AI_GOVERNANCE_ENABLED || '').toLowerCase() === 'true'
}

export function isAiKnowledgeUiEnabled() {
    return String(process.env.VUE_APP_AI_KNOWLEDGE_ENABLED || '').toLowerCase() === 'true'
}

export function resolveAiGovernanceFunctionalityId() {
    return AI_GOVERNANCE_FUNCTIONALITY_ID
}

export function canAccessAiGovernance(funcionalidades = []) {
    if (!isAiGovernanceUiEnabled()) {
        return false
    }

    return funcionalidades.includes(AI_GOVERNANCE_FUNCTIONALITY_ID)
}

export function knowledgeMaxFileMb() {
    const parsed = Number.parseInt(String(process.env.VUE_APP_AI_KNOWLEDGE_MAX_FILE_MB || '20'), 10)
    return Number.isInteger(parsed) && parsed > 0 ? parsed : 20
}
